import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

import FastClick from "fastclick";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const state = reactive({ transitionName: "slide-left" });
router.beforeEach((to, from) => {
  if ((to.meta.index as string) > (from.meta.index as string)) {
    state.transitionName = "slide-left"; // 向左滑动
  } else if ((to.meta.index as string) < (from.meta.index as string)) {
    // 由次级到主级
    state.transitionName = "slide-right";
  } else {
    state.transitionName = "";   // 同级无过渡效果
  }
});

onMounted(() => {
  (FastClick as any).attach(document.body);
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { class: "router-view" }, {
    default: _withCtx(({Component}) => [
      _createVNode(_Transition, {
        name: state.transitionName
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 2
      }, 1032, ["name"])
    ]),
    _: 1
  }))
}
}

})